import React from "react";
import "./home-page.styles.scss";
import { GlobalState } from "../../redux/root-reducer";
import { connect } from "react-redux";
import { User } from "../../@types/user.interface";
import Welcome from "../../assets/images/svg/undraw_Hello_qnas.svg";

interface IProps {
    user: User | null;
}

function HomeContainer({ user }: IProps) {
    return (
        <div className="container">
            <div className="container__content">
                <div className="home-page">
                    <div className="title">
                        <h2 className="heading">Home</h2>
                    </div>
                    <div className="home-page__detail">
                        <div className="home-page__detail__items">
                            <img
                                className="home-page__detail__items__image"
                                src={Welcome}
                                alt="Welcome"
                            />
                            <h2 className="home-page__detail__items__heading">
                                Hello,{" "}
                                {user?.initial ? user?.initial : user?.name}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({ user: { self } }: GlobalState) => ({
    user: self.data,
});

const HomePage = connect(mapStateToProps)(HomeContainer);

export default HomePage;
